import { render, staticRenderFns } from "./inspect-outer-form.vue?vue&type=template&id=c2e75dc8&"
import script from "./inspect-outer-form.vue?vue&type=script&lang=js&"
export * from "./inspect-outer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports